<template>
    <div>
        <v-card>
            <div v-padding.left="3" v-padding.right="3" v-padding.top="2" v-padding.bottom="2">
                <v-text type="headline">Баланс</v-text>
            </div>

            <div v-padding.left="3" v-padding.right="3" v-padding.top="1" v-padding.bottom="4">
                <v-row>
                    <v-col xs="3">
                        <tariff-card title="Баланс аккаунта">
                            {{ numberWithSpaces(balance) }}
                        </tariff-card>
                    </v-col>

                    <v-col xs="3" v-if="profileTariff">
                        <tariff-card title="Баланс тарифа">
                            {{ numberWithSpaces(profileTariff.balance) }}
                        </tariff-card>
                    </v-col>
                </v-row>
            </div>
        </v-card>

        <v-card v-margin.top="3">
            <div v-padding.left="3" v-padding.right="3" v-padding.top="2" v-padding.bottom="2">
                <v-text type="headline">Пополнение баланса аккаунта</v-text>
            </div>

            <div v-if="(isIdentified ? true : isFilled)" v-padding.left="3" v-padding.right="3" v-padding.bottom="3">
                <v-row>
                    <v-col xs="5" sm="4">
                        <v-form :defaultValues="defaultValues" @submit="handleSubmit"
                            :validate="validateCreatePaymentForm" :readonly="isPaying">
                            <template scope="api">
                                <v-form-input v-margin.bottom="2" field="amount" type="number" maxlength="7" 
                                    label="Сумма оплаты" />
                                <div>
                                    <v-text>Оплатить с помощью</v-text>
                                    <v-form-radio v-margin.top="2" :key="1" field="method" :data="'1'"
                                        :label="'Безналичный счет'" :clickEvent="changeBtnName" />
                                    <v-tooltip v-if="!isIdentified"
                                        text="Для оплаты через онлайн банкинг необходимо пройти процедуру идентификации">
                                        <v-form-radio :disabled="true" v-margin.top="2" :key="2" field="method"
                                            :data="'2'" :label="'Банковская карта, СБП'" :clickEvent="changeBtnName" />
                                    </v-tooltip>
                                    <v-form-radio v-else v-margin.top="2" :key="2" field="method" :data="'2'"
                                        :label="'Банковская карта, СБП'" :clickEvent="changeBtnName" />
                                </div>

                                <v-form-checkbox v-margin.top="2" field="isAgree" data=true>
                                    <template slot="label" scope="label">
                                        <v-text>
                                            Подтверждаю согласие с
                                            <v-link pointer
                                                @click="openNewWindow('https://exbico.ru/oferta_und')">Лицензионным
                                                соглашения</v-link>
                                        </v-text>
                                    </template>
                                </v-form-checkbox>

                                <div v-margin.top="3">
                                    <v-spinner :active="isPaying">
                                        <v-button type="submit" primary :disabled="api.isInvalid || isPaying">
                                            {{ btnName }}
                                        </v-button>
                                    </v-spinner>
                                </div>
                            </template>
                        </v-form>
                    </v-col>
                </v-row>
            </div>
            <div v-else v-padding.left="3" v-padding.right="3" v-padding.bottom="3">
                <v-row>
                    <v-col xs="6" sm="6">
                        <div>
                            <v-text danger>Для оплаты услуг необходимо заполнить профиль</v-text>
                        </div>
                    </v-col>
                    <v-col v-text-align.right>
                        <div>
                            <v-link :to="'/profile'">
                                Заполнить профиль
                            </v-link>
                        </div>
                    </v-col>
                </v-row>
            </div>
        </v-card>

        <payment-history v-margin.top="3" />

        <v-alert success v-margin.top="3">
            <div v-padding="2">
                <div>
                    <v-text type="subheadling">Режим работы по зачислению средств</v-text>
                </div>
                <v-text>
                    Пн-пт — 8:00-17:00 (время московское)
                    <br>Сб-вс — выходной
                    <br>Email support@exbico.ru
                    <br>Телеграм <a href="https://t.me/lkexbico_bot" target="_blank">бот</a>
                </v-text>
            </div>
        </v-alert>
    </div>
</template>

<script>
import { PaymentHistory } from "../paymentHistory";
import { validateCreatePaymentForm } from "./validate";
import { METHODS_STRING, METHODS, BTN_NAME } from "./constants";
import theme from "./theme.scss";
import { numberWithSpaces, declOfNum } from '../../../helpers';
import moment from 'moment';
import { TariffCard } from '../tariffCard';
import CloseTariff from "../requestProducts/CloseTariffContainer.vue";

export default {
    components: {
        PaymentHistory,
        TariffCard,
        CloseTariff
    },
    name: "pricing",
    props: {
        balance: Number,
        isFilled: Boolean,
        isIdentified: Boolean,
        onCreatePayment: Function,
        tariffs: {
            type: Array,
            default() {
                return [];
            }
        },
        products: {
            type: Array,
            default() {
                return [];
            }
        },
        profileTariff: Object,
        theme: {
            type: Object,
            default() {
                return theme;
            }
        }
    },
    data() {
        return {
            methodsString: METHODS_STRING,
            isPaying: false,
            defaultValues: {
                method: this._props.isIdentified ? METHODS.Card.toString() : METHODS.Cash.toString(),
                isAgree: []
            },
            btnName: BTN_NAME[this._props.isIdentified ? METHODS.Card : METHODS.Cash]
        };
    },
    methods: {
        validateCreatePaymentForm,
        numberWithSpaces,
        moment,
        labelDays(daysLeft) {
            return declOfNum(daysLeft, [
                'день',
                'дня',
                'дней',
            ]);
        },

        btnIsDisabled(products) {
            const maxProducCost = Math.max(...products.map(p => p.cost), 0);
            return !!this.profileTariff.balance && this.profileTariff.balance > maxProducCost
        },

        changeBtnName(id) {
            this.btnName = BTN_NAME[id];
        },

        openNewWindow(url) {
            window.open(url, '_blank');
        },

        handleSubmit(values) {
            const data = { ...values, method: parseInt(values.method) }
            delete data.isAgree
            if (this.isPaying) {
                return;
            }

            this.isPaying = true;

            this.onCreatePayment(data)
                .then(res => {
                    this.isPaying = false;
                })
                .catch(res => {
                    this.isPaying = false;
                });
        }
    }
};
</script>


// WEBPACK FOOTER //
// Pricing.vue?5a6fa1f0